<mat-card>
  <h1 translate="parameters/send-by-email-settings/title"></h1>
  <p translate="parameters/send-by-email-settings/presentation"></p>

  <form [formGroup]="form">
    <!-- toggle enabled -->
    <div class="field">
      <mat-slide-toggle formControlName="enabled"
        ><span translate="parameters/send-by-email-settings/toogle"></span
      ></mat-slide-toggle>
    </div>

    <!-- sender email -->
    <div class="field">
      <mat-form-field>
        <mat-label translate="parameters/send-by-email-settings/sender-email"></mat-label>
        <input matInput formControlName="senderEmail" />
        <mat-error
          *ngIf="form.controls.senderEmail.errors?.email"
          translate="common/form_errors/invalid-email"></mat-error>
        <mat-error
          *ngIf="form.controls.senderEmail.errors?.required"
          translate="common/form_errors/required"></mat-error>
      </mat-form-field>
    </div>

    <!-- sender name -->
    <div class="field">
      <mat-form-field>
        <mat-label translate="parameters/send-by-email-settings/sender-name"></mat-label>
        <input matInput formControlName="senderName" />
        <mat-error
          *ngIf="form.controls.senderName.errors?.required"
          translate="common/form_errors/required"></mat-error>
      </mat-form-field>
    </div>

    <!-- mandatory recipient -->
    <div class="field">
      <mat-form-field>
        <mat-label translate="parameters/send-by-email-settings/mandatory-recipients"></mat-label>
        <mat-chip-list #chipListMandatoryRecipients>
          <mat-chip
            *ngFor="let recipient of form.value.mandatoryRecipients"
            (removed)="removeMandatoryRecipient(recipient)">
            {{ recipient }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
          <input
            formControlName="mandatoryRecipient"
            [matChipInputFor]="chipListMandatoryRecipients"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addRecipient($event)" />
        </mat-chip-list>
        <mat-hint translate="parameters/send-by-email-settings/mandatory-recipients/hint"></mat-hint>
        <mat-error
          *ngIf="chipListMandatoryRecipients.errorState && recipientError === chipListCustomErrorEnum.invalid"
          translate="common/form_errors/invalid-email"></mat-error>
        <mat-error
          *ngIf="chipListMandatoryRecipients.errorState && recipientError === chipListCustomErrorEnum.exists"
          translate="parameters/send-by-email-settings/mandatory-recipients/error/exists"></mat-error>
      </mat-form-field>
    </div>

    <!-- authorized domains -->
    <div class="field">
      <mat-form-field>
        <mat-label translate="parameters/send-by-email-settings/authorized-domains"></mat-label>
        <mat-chip-list #chipListauthorizedDomains>
          <mat-chip *ngFor="let domain of form.value.authorizedDomains" (removed)="removeDomain(domain)">
            {{ domain }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
          <input
            formControlName="authorizedDomain"
            [matChipInputFor]="chipListauthorizedDomains"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addDomain($event)" />
        </mat-chip-list>
        <mat-hint translate="parameters/send-by-email-settings/authorized-domains/hint"></mat-hint>
        <mat-error
          *ngIf="chipListauthorizedDomains.errorState && this.domainError === chipListCustomErrorEnum.invalid"
          translate="parameters/send-by-email-settings/authorized-domains/error/invalid"></mat-error>
        <mat-error
          *ngIf="chipListauthorizedDomains.errorState && this.domainError === chipListCustomErrorEnum.exists"
          translate="parameters/send-by-email-settings/authorized-domains/error/exists"></mat-error>
      </mat-form-field>
    </div>

    <!-- reply to -->
    <div class="field">
      <div class="side-by-side">
        <mat-form-field>
          <mat-label translate="parameters/send-by-email-settings/reply-to"></mat-label>
          <mat-select formControlName="replyToEmailMode">
            <mat-option *ngFor="let item of replyToEmailModeEnum" [value]="item"
              ><span [translate]="'parameters/send-by-email-settings/reply-to/' + item"></span
            ></mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="displayReplyToEmail">
          <mat-label translate="parameters/send-by-email-settings/reply-to/email"></mat-label>
          <input matInput formControlName="replyToOtherEmail" />
          <mat-error
            *ngIf="form.controls.replyToOtherEmail.errors?.email"
            translate="common/form_errors/invalid-email"></mat-error>
          <mat-error
            *ngIf="form.controls.replyToOtherEmail.errors?.required"
            translate="common/form_errors/required"></mat-error>
        </mat-form-field>
      </div>

      <div
        class="hint-wrapper"
        [ngClass]="{
          'error-displayed': form.controls.replyToOtherEmail.touched && form.controls.replyToOtherEmail.errors
        }">
        <mat-hint>
          <span translate="parameters/send-by-email-settings/reply-to/hint-1"></span><br />
          <span translate="parameters/send-by-email-settings/reply-to/hint-2"></span>
        </mat-hint>
      </div>
    </div>

    <!-- object -->
    <div class="field">
      <mat-form-field>
        <mat-label
          ><span translate="parameters/send-by-email-settings/default-object"></span> (<span
            translate="parameters/send-by-email-settings/default-hint"></span
          >)</mat-label
        >
        <input matInput formControlName="defaultObject" />
        <mat-hint translate="parameters/send-by-email-settings/user-replacement-hint"></mat-hint>
      </mat-form-field>
    </div>

    <!-- content -->
    <div class="field">
      <mat-form-field>
        <mat-label translate="parameters/send-by-email-settings/default-comment"></mat-label>
        <textarea matInput formControlName="defaultComment"></textarea>
        <mat-hint translate="parameters/send-by-email-settings/user-replacement-hint"></mat-hint>
      </mat-form-field>
    </div>

    <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="form.invalid || form.pristine">
      <span translate="save"></span>
    </button>

    <button mat-flat-button type="button" (click)="reset()"><span translate="cancel"></span></button>
  </form>
</mat-card>
